import documentReady from 'document-ready';
import Mounter from './shared/utils/mounter';
import InformCookiesPopup from './cookies/inform_cookies_popup';

documentReady(() => {
  new Mounter({
    InformCookiesPopup,
  }).mountAll();
});
